import { Button, Form, Alert, Modal, Tag } from "antd";
import { useFetchEligibleDebtorsForMergeQuery } from "features/debtorSider/agencyPortal/debtorSiderAPI";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";

const StyledCard = styled.div`
  margin-top: 0px;
  margin-left: 8px;
`;

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledButton = styled(Button)`
  margin-top: 8px;
`;

export default function SimilarDebtorsCard({ currentDebtor }) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { data: mergedEligibleDebtors } = useFetchEligibleDebtorsForMergeQuery({
    debtorIds: [currentDebtor?.id],
  });

  const navigate = useNavigate();

  if (mergedEligibleDebtors?.length) {
    if (mergedEligibleDebtors[0]?.asyncJob?.id) {
      return (
        <Alert
          showIcon
          message="This debtor will soon be archived."
          description={
            <>
              <div>
                This debtor is currently being merged with another debtor. This process may take a
                few minutes. Please check back later.
              </div>
              <StyledButton
                onClick={() => navigate(`/debtors/${mergedEligibleDebtors[0]?.parentDebtorId}`)}
                type="primary"
              >
                View Debtor
              </StyledButton>
            </>
          }
          type="warning"
        />
      );
    }
    return (
      <>
        <Alert
          showIcon
          message={`${mergedEligibleDebtors[0]?.childrenDebtors?.length} duplicate(s) found `}
          description={
            <>
              <div>
                Debtors with similar profiles were detected. Merging the duplicates will combine
                them into one debtor.
              </div>
              <StyledButton onClick={() => setIsModalVisible(true)} type="primary">
                See Details
              </StyledButton>
            </>
          }
          type="warning"
        />
        {isModalVisible && (
          <Modal
            open={isModalVisible}
            title="Similar Debtors Found"
            width={800}
            onOk={() => setIsModalVisible(false)}
            maskClosable={false}
            onCancel={() => setIsModalVisible(false)}
          >
            <StyledCard>
              <Form labelAlign="left">
                {mergedEligibleDebtors[0]?.parentDebtorId !== currentDebtor?.id && (
                  <StyledContainer>
                    <span>
                      <a
                        href={`/debtors/${mergedEligibleDebtors[0]?.parentDebtorId}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {mergedEligibleDebtors[0]?.parentDebtor?.name} (
                        {mergedEligibleDebtors[0]?.parentDebtor?.externalId})
                      </a>
                      <Tag>PARENT</Tag>
                    </span>
                  </StyledContainer>
                )}
                {mergedEligibleDebtors[0]?.childrenDebtors
                  ?.filter((debtor) => debtor.id !== currentDebtor?.id)
                  ?.map((debtor) => (
                    <StyledContainer key={debtor.id}>
                      <span>
                        <a href={`/debtors/${debtor?.id}`} target="_blank" rel="noreferrer">
                          {debtor.name} ({debtor.externalId})
                        </a>
                        <Tag>CHILD</Tag>
                      </span>
                    </StyledContainer>
                  ))}
              </Form>
            </StyledCard>
          </Modal>
        )}
      </>
    );
  }

  return null;
}
